import type { Template } from "@/types";

export const PO_03_H3_V0: Template[] = [
{
    id: "po-03-h3v0-01",
    name: "PO 01 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 54, y: 299, width: 365, height: 254, rotation: 0, imageRotation: 0 },
            { id: "2", x: 426, y: 299, width: 365, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 798, y: 299, width: 365, height: 254, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-02",
    name: "PO 02 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 286, width: 401, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 408, y: 286, width: 401, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 817, y: 286, width: 400, height: 280, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-03",
    name: "PO 03 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 63, y: 85, width: 483, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 429, width: 483, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 671, y: 257, width: 483, height: 336, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-04",
    name: "PO 04 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 63, y: 85, width: 483, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 429, width: 483, height: 336, rotation: 0, imageRotation: 0 },
            { id: "3", x: 609, y: 214, width: 609, height: 421, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-05",
    name: "PO 05 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 99, y: 169, width: 334, height: 252, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 429, width: 334, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 441, y: 169, width: 677, height: 513, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-06",
    name: "PO 06 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 270, y: 97, width: 676, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 512, width: 334, height: 243, rotation: 0, imageRotation: 0 },
            { id: "3", x: 612, y: 512, width: 334, height: 243, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-07",
    name: "PO 07 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 369, y: 120, width: 848, height: 609, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 120, width: 361, height: 301, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 429, width: 361, height: 300, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-08",
    name: "PO 08 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 56, y: 148, width: 326, height: 273, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 429, width: 326, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 148, width: 771, height: 553, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-09",
    name: "PO 09 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 111, y: 185, width: 698, height: 481, rotation: 0, imageRotation: 0 },
        { id: "2", x: 817, y: 185, width: 290, height: 237, rotation: 0, imageRotation: 0 },
        { id: "3", x: 817, y: 430, width: 290, height: 236, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-10",
    name: "PO 10 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 64, y: 257, width: 483, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 672, y: 85, width: 483, height: 337, rotation: 0, imageRotation: 0 },
            { id: "3", x: 672, y: 429, width: 483, height: 336, rotation: 0, imageRotation: 0 }
    ],
}
];